import Vue from 'vue';
import Axios from 'axios';
import ApiUrl from '../apiurl';
import Mock from '../mock/Mock.js';
import { stat } from 'fs';
import { Alert } from 'element-ui';

let nextid = 1;

export default {
    namespaced: true,
  
    state: {
        // 模糊搜索字段
        searchCategories: [],
        // 常用搜索词
        commonSearchKeywords: [],
        // 搜索结果
        searchResult: [],
        hasSearchResult:false,
        // 已选择的车辆
        selectionResult: [],
        // 全部搜索字段
        searchSchema: {},
        searchParams:{},
        // 当前搜索字段
        currentSearchSchema: {
            cols: [{ id: '2006', value: 'MSRP', type: 'number-range', unit: 'RMB', min: 100000, max: 10000000, step: 100 }]
        },
        // 保存的搜索方案
        savedSearchSchemas: [],
        //保存的结果方案
        savedResultSchemas: [],
        // 透视表JSON
        pivotTableUri: null,
        //最后选择的结果集生成key，保存，用于请求数据
        pivotTableKey :null,
        moduleName:'sale',
        currentModuleName:'sale',
    },

    getters: {
        // 模糊搜索字段
        searchCategories: (state) => {
            return state.searchCategories;
        },
        // 常用搜索词
        commonSearchKeywords: (state) => {
            return state.commonSearchKeywords;
        },
        // 搜索结果
        searchResult: (state) => {
            return state.searchResult;
        },
        // 搜索参数
        searchParams:(state) =>{
            return state.searchParams;
        },
        // 搜索结果ID列表
        searchResultID: (state) => {
            return state.searchResult.map(item => item.id);
        },
        // 已选择的结果
        selectionResult: (state) => {
            return state.selectionResult;
        },
      
    
        // 已选结果列表
        selectionResultID(state) {
            return state.selectionResult.map(item => item.id);
        },
        // 全部搜索字段
        searchSchema: (state) => {
            let ret = [];
            for(let key in state.searchSchema) {
                const schema = state.searchSchema[key];
                let cols = schema && schema.cols;
                if(Array.isArray(cols)) {
                    ret = [...ret, ...cols]
                }
            }
            return ret;
        },
        // 获取字段配置
        getSearchSchema: (state, getters) => (id) => { 
            return getters.searchSchema.find(item => item.id === id); 
        },

        // 当前搜索字段设置
        currentSearchSchema: (state) => {
            return state.currentSearchSchema;
        },
        // 保存的搜索方案
        savedSearchSchemas: (state) => {
            return state.savedSearchSchemas;
        },
         // 保存的结果方案
        savedResultSchemas:(state) =>{
            return state.savedResultSchemas;
        },
        // 透视表JSON数据
        pivotTableUri: (state) => {
            return state.pivotTableUri;
        },
    //设置当前模块名
    currentModuleName: (state) => {
        return state.currentModuleName;
    },
         //最后选择的结果集生成key，保存，用于请求数据
        pivotTableKey:(state)=>{
            return state.pivotTableKey;
        },
        hasSearchResult: (state) => {
            return state.hasSearchResult;
        },
    },

    mutations: {
        // 搜索结果
        setSearchResult(state, newValue) {
         
          //  this.dispatch('setHasSearchResult', true);
            if(Array.isArray(newValue)) {
                Vue.set(state, 'searchResult', [...newValue]);
            }
        },
        setHasSearchResult(state, newValue) {
           // state.hasSearchResult = newValue;  
            Vue.set(state, 'hasSearchResult',newValue);
        },
        // 模糊搜索字段
        setSearchCategories(state, newValue) {
            if(Array.isArray(newValue)) {
                Vue.set(state, 'searchCategories', [...newValue]);
            }
        },
            //设置当前模块名
            setCurrentModuleName(state,newValue) {
                Vue.set(state, 'currentModuleName',newValue);
            },
        // 常用搜索词
        setCommonSearchKeywords(state, newValue) {
            if(Array.isArray(newValue)) {
                Vue.set(state, 'commonSearchKeywords', [...newValue]);
            }
        },

        // 全部搜索字段
        setSearchSchema(state, newValue) {
            if(newValue) {
                Vue.set(state, 'searchSchema', {...newValue} );
            }
        },
       setSearchParams(state,newValue)
       {
           if(newValue)
           {
               Vue.set(state,'searchParams',{...newValue});
           }
       },
        // 设置当前搜索字段设置
        setCurrentSearchSchema(state, newValue) {
            if(newValue) {
                Vue.set(state, 'currentSearchSchema', {...newValue});
            }
        },

        // 清空当前搜索字段
        clearCurrentSearchSchema(state) {
            Vue.set(state, 'currentSearchSchema', { cols: [] });  
        },

        // 设置保存搜索方案
        setSavedSearchSchemas(state, newValue) {
            if(Array.isArray(newValue)) {
                console.log(newValue);
                Vue.set(state, 'savedSearchSchemas', [...newValue]);
            }  
        },
          // 设置保存结果方案
          setSavedResultSchemas(state, newValue) {
            if(Array.isArray(newValue)) {
                console.log(newValue);
                Vue.set(state, 'savedResultSchemas', [...newValue]);
            }  
        },
       
        
        // 添加/更新保存的搜索方案
        upsertSavedSearchSchema(state, newValue) {
      
            if(newValue && newValue.id) {
                let i = state.savedSearchSchemas.findIndex( item => item.id && item.id === newValue.id );
                if(i === -1) {
                    state.savedSearchSchemas.push(newValue);
                } else {
                    Vue.set(state.savedSearchSchemas, i,{...newValue} );  
                }
            }
        },

        // 设置已选结果
        setSelectionResult(state, newValue) {
            if(Array.isArray(newValue)) {
                Vue.set(state, 'selectionResult', [...newValue]);
            }
        },

        // 添加已选结果
        addSelectionResult(state, appendValues) {
            console.log(appendValues);
            if(Array.isArray(appendValues)) {
                const filteredValues = appendValues.filter((item) => {
                    return state.selectionResult.findIndex((obj) => {
                        return obj.id === item.id;
                    }) === -1;
                });
                state.selectionResult = [...state.selectionResult, ...filteredValues];
            }
        },

        // 删除已选结果
        deleteSelectionResult(state, params) {
            if(params) {
                state.selectionResult = state.selectionResult.filter((item) => {
                    for(let key in params) {
                        if(params[key] && item[key] === params[key]) {
                            return false;
                        }
                    }
                    return true;
                });
            }
        },

        // 设置透视表JSON数据
        setPivotTableUri(state, uri) {
            state.pivotTableUri = uri;  
        },
        // 设置透视表key
        setPivotTableKey(state,key)
        {
            state.pivotTableKey = key;
        },
    },

    actions: {

        async saveLinesPivotTableAsync({commit,state},{key,cb}){

            try {
               let ids =  state.selectionResult.map((item)=>{ return parseInt(item.id) }); 
                var  postData = {
                    key: key,  
                    value: ids 
                }  
                const rsp = await Axios.post(ApiUrl.salesanalysis.setserializeobject,postData);
                if(rsp && rsp.data && rsp.data.success) {
                    console.log(rsp.data.result);                   
                    cb && cb(rsp.data.result);      
                }
            } catch(e) {
                console.error(e);
            } finally {
   
            }
        },
        async getSelectionByPivotTableKey({commit},pivotTableKey){
           

        },
        async savePivotTableAsync({commit,state},{key,cb}){

            try {
              // let ids =  state.selectionResult.map((item)=>{ return parseInt(item.id) }); //车款的，作废
                var models = state.selectionResult.filter((item, index) => {return state.selectionResult.findIndex((obj) => { return obj.model === item.model; }) === index });;
                //  alert(JSON.stringify(models));
                  let ids =  models.map((item)=>{ return parseInt(item.modeId) });
                  console.log("test---:");
                 console.log(models);
                var  postData = {
                    key: key,  
                    value: ids 
                }  
                const rsp = await Axios.post(ApiUrl.salesanalysis.setserializeobject,postData);
                if(rsp && rsp.data && rsp.data.success) {
                    console.log(rsp.data.result);                   
                    cb && cb(rsp.data.result);      
                }
            } catch(e) {
                console.error(e);
            } finally {
   
            }
        },
        async getSelectionByPivotTableKey({commit},pivotTableKey){
           

        },
   
        async getPivotTable({commit,state},{key,cb,daterange,source,datatype})
        {
            try {
                var  postData = {
                    key: key,  
                    daterange:daterange,  
                    source: source,
                    datatype:datatype
                }  
                const rsp = await Axios.post(ApiUrl.salesanalysis.getpivottable,postData);
                if(rsp && rsp.data && rsp.data.success) {                
                    cb && cb(rsp.data.result);
                    
                }
            } catch(e) {
                console.error(e);
            } finally {
   
            }

        },
        async saveSerializeObjectAsync({commit},{key,value,cb}){

            try {
                commit('startLoading', null, { root: true });
                var  postData = {
                    key: key, // 方案类型 search 搜索条件 | result 结果集
                    value: value// 当type == result时 传车款id列表
                } ; 
                const rsp = await Axios.post(ApiUrl.salesanalysis.setserializeobject,postData);
                if(rsp && rsp.data && rsp.data.success) {
                    console.log(rsp.data.result);                   
                  
                     cb & cb(rsp.data.result);
                  
                }
            } catch(e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        // 获取搜索配置
        async getSearchSchemaAsync({commit}) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await Axios.post(ApiUrl.salesanalysis.searchconfig);
                if(rsp && rsp.data && rsp.data.success) {
                    console.log(rsp.data.result);                   
                 commit('setSearchCategories', rsp.data.result.basic.cols);
                 commit('setSearchSchema', rsp.data.result);
                }
            } catch(e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },

        // 获取常用搜索词
        async getCommonSearchKeywordAsync({commit,state}) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await Axios.post(ApiUrl.salesanalysis.querytag,{'module': state.currentModuleName});
                if(rsp && rsp.data && rsp.data.success) {
                    console.log(rsp.data.result);
                    commit('setCommonSearchKeywords', rsp.data.result);
                }
            } catch(e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
        },

        // 搜索
        async doSearch({commit, state, getters}, params) {
             var postData = await params;
             console.log("postData= ");
             console.log(postData );
 
            try {
                commit('startLoading', null, { root: true });
                const rsp = await Axios.post(ApiUrl.salesanalysis.search,postData);
                if(rsp && rsp.data && rsp.data.success) {
                 //   console.log(rsp.data.result);
                 alert('back data');
                 //    var  has = rsp.data.result.length>0;
                  //  commit('setHasSearchResult', has);
                 //   commit('setSearchResult', rsp.data.result);
                } 
              //  commit('setSearchResult', Mock.searchResult);
            } catch(e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
        },
              // 搜索, 通过ID数组
        async doSearchByIds({commit, state, getters}, params) {
                var postData = await params;
                console.log("postData= ");
                console.log(postData );
               try {
                   commit('startLoading', null, { root: true });
                   const rsp = await Axios.post(ApiUrl.salesanalysis.searchbyids,postData);
                   if(rsp && rsp.data && rsp.data.success) {
                    //   console.log(rsp.data.result);
                       commit('setHasSearchResult', rsp.data.result.length>0);
                       commit('setSearchResult', rsp.data.result);
                   }
                 //  commit('setSearchResult', Mock.searchResult);
               } catch(e) {
                   console.error(e);
               } finally {
                   commit('stopLoading', null, {root: true});
               }
           },
        async initSavedResultSchema({commit,state}){
            try {
                const rsp = await Axios.post(ApiUrl.salesanalysis.resultschemalist,{'module': state.currentModuleName});
                if(rsp && rsp.data && rsp.data.success) {
                    // var arr = new Array();
                    // for(var s in rsp.data.result)
                    // {
                    //     var rt = JSON.parse(rsp.data.result[s].search);
                    //     arr.push(rt); 
                    // }                   
                    commit('setSavedResultSchemas', rsp.data.result);
                }

                 


            } catch(e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
           //  var sc =[{"name":"方案1","id":"10086"},{"name":"方案2","id":"10088"}] ;   // {"type":"result","results":[{"name":"方案1","id":"10086"},{"name":"方案2","id":"10088"}]};
          //  commit('setSavedResultSchemas', sc);
        },
        async initSavedSearchSchema({commit,state} ){
            try {
                commit('startLoading', null, { root: true });
                const rsp = await Axios.post(ApiUrl.salesanalysis.searchschemalist,{'module': state.currentModuleName});
                if(rsp && rsp.data && rsp.data.success) {
                    var arr = new Array();
                    for(var s in rsp.data.result)
                    {
                        var rt = JSON.parse(rsp.data.result[s].json);
                        rt['id'] = rsp.data.result[s].id;
                        rt['name'] = rsp.data.result[s].name;
                        arr.push(rt); 
                    }   
                              
                    commit('setSavedSearchSchemas', arr);
                }
            } catch(e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
        },
        async saveSelectionResultSchema({commit, state,dispatch}, {schemaId,name, cb}){
            let ids = state.selectionResult.map((item)=>{ return item.id});
            try {
                commit('startLoading', null, { root: true });
                var  postData = {
                     type: "result", // 方案类型 search 搜索条件 | result 结果集
                     name:name,
                     id:schemaId,
                     module:state.currentModuleName,
                     json: ids// 当type == result时 传车款id列表
                }              
                const rsp = await Axios.post(ApiUrl.salesanalysis.savesearchschema ,postData);
                if(rsp && rsp.data && rsp.data.success) {
                    console.log(rsp.data.result);
                  //  commit('setSavedSearchSchema', rsp.data.result);
                  console.log(state);
                   dispatch('initSavedResultSchema');
                }
            } catch(e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
        },
        // 保存结果集方案
        async saveCurrentSearchSchema({commit, state}, {schemaId, name,action, cb}) {
    
          //  alert('保存搜索方案');
            let currentSchema = state.currentSearchSchema;
            if(name) {
                currentSchema.name = name;
            }
            currentSchema.id=  schemaId;

            var saveSchema = {
                cols: currentSchema.cols.map(item => {
                    return item.id;
                }),
                searchParams: currentSchema['searchParams'] 
            };            
               
            try {

                var  postData = {
                    id:schemaId,
                    type: "search", // 方案类型 search 搜索条件 | result 结果集
                    json: saveSchema ,
                    module :state.moduleName,
                    action:action,
                    name: name,
                } 
                console.log(postData);
                const rsp = await Axios.post(ApiUrl.salesanalysis.savesearchschema ,postData);
                if(rsp && rsp.data && rsp.data.success) {
                    console.log(rsp.data.result);
                  //  commit('setSavedSearchSchema', rsp.data.result);
                }
            } catch(e) {
                console.error(e);
            } 
              
            saveSchema['id'] = schemaId;
            saveSchema['name']  = name ;
            commit('upsertSavedSearchSchema', saveSchema);
            commit('setCurrentSearchSchema', currentSchema);
            cb && cb(true);
        },

        // 选择保存搜索方案
        selectSavedSearchSchema({commit, state, getters}, id) {
            for(let i = 0, len = state.savedSearchSchemas.length; i < len; ++i) {
                if(state.savedSearchSchemas[i].id === id) {
                    let schema = {...state.savedSearchSchemas[i]};
                    if(schema.cols) {
                        schema.cols = schema.cols.map(id => {
                            return getters.getSearchSchema(id);
                        }).filter(item => {
                            return !!item;
                        });
                    }
                    commit('setCurrentSearchSchema', schema);
                    return;
                }
            }
        },

        async loadResultSchemaData({commit, state, getters}, {id, cb})
        {
            
            try {
                commit('startLoading', null, { root: true });
       
                const rsp = await Axios.post(ApiUrl.salesanalysis.searchbyresultschema ,{id:id});
                if(rsp && rsp.data && rsp.data.success) {
                    var  has = rsp.data.result.length>0;
                    commit('setHasSearchResult', has);
                   // commit('setSearchResult', rsp.data.result);
                    commit('setSelectionResult',rsp.data.result);
                    
                   cb && cb(true);
                }
            } catch(e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
          
       
          
        },
   
        // 获取透视表文件地址
        async getPivotTable2222({commit, getters}, type) {
            try {
                commit('startLoading', null, { root: true });
                let data = type === 'selection' ? getters.selectionResultID : getters.searchResultID;
                console.log(data);
                let rsp = await Axios.post(ApiUrl.salesanalysis.getpivottable, JSON.stringify([{'productLineId': '0'}]));
                if(rsp && rsp.data && rsp.data.success) {
                    commit('setPivotTableUri', rsp.data.result);
                    return rsp.data.result;
                }
                return null;
            } catch(e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
            
        }
    },
}